import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

export default defineNuxtPlugin((nuxtApp) => {
  const {
    isEnabledEcho,
    echoAuthEndpoint,
    echoKey,
    echoCluster,
    echoHost,
    echoPost,
  } = nuxtApp.$config.public

  window.Pusher = Pusher

  return {
    provide: {
      echo: isEnabledEcho
        ? new Echo({
            broadcaster: 'pusher',
            key: echoKey,
            wsHost: echoHost,
            cluster: echoCluster,
            wsPort: echoPost,
            forceTLS: false,
            disableStats: true,
            encrypted: true,
            authEndpoint: echoAuthEndpoint,
          })
        : null,
    },
  }
})
